import script from "./UserSearchPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UserSearchPage.vue?vue&type=script&setup=true&lang=js"

import "./UserSearchPage.vue?vue&type=style&index=0&id=46d6933b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46d6933b"]])

export default __exports__